/* ===========================================================
   Carrera de Cotorros — Shopify theme JS (no dependencies)
   Scroll reveal · parallax · count-up · marquee(css) · FAQ ·
   mobile menu · sticky buy bar · AJAX cart.
   =========================================================== */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Enable hidden start-state for reveals only when JS runs (+ motion allowed). */
  if (!reduceMotion) document.documentElement.classList.add("cc-anim");

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal, .reveal-x, .reveal-pop");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });

    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.96 && r.bottom > 0) { el.classList.add("in"); }
      else { io.observe(el); }
      // failsafe: never leave content hidden
      setTimeout(function () { el.classList.add("in"); }, 2800);
    });
  }

  /* ---------- Parallax (data-parallax="speed") ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var nodes = [].slice.call(document.querySelectorAll("[data-parallax]"));
    if (!nodes.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      nodes.forEach(function (n) {
        var r = n.getBoundingClientRect();
        var center = r.top + r.height / 2 - vh / 2;
        var sp = parseFloat(n.getAttribute("data-parallax")) || 0.1;
        n.style.transform = "translateY(" + (-center * sp).toFixed(1) + "px)";
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  /* ---------- Count-up (data-count="number") ---------- */
  function initCountUp() {
    var nodes = [].slice.call(document.querySelectorAll("[data-count]"));
    if (!nodes.length) return;
    function run(node) {
      var to = parseFloat(node.getAttribute("data-count")) || 0;
      var suffix = node.getAttribute("data-suffix") || "";
      if (reduceMotion) { node.textContent = to.toLocaleString("es-MX") + suffix; return; }
      var dur = 1400, t0 = null;
      function tick(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        node.textContent = Math.round(to * eased).toLocaleString("es-MX") + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    if (!("IntersectionObserver" in window)) { nodes.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    var items = [].slice.call(document.querySelectorAll(".cc-faq__item"));
    items.forEach(function (item) {
      var q = item.querySelector(".cc-faq__q");
      var a = item.querySelector(".cc-faq__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("open");
        items.forEach(function (it) {
          it.classList.remove("open");
          var aa = it.querySelector(".cc-faq__a"); if (aa) aa.style.maxHeight = "0px";
        });
        if (!isOpen) { item.classList.add("open"); a.style.maxHeight = a.scrollHeight + "px"; }
      });
    });
    // open first by default
    if (items[0]) {
      var a0 = items[0].querySelector(".cc-faq__a");
      items[0].classList.add("open");
      if (a0) a0.style.maxHeight = a0.scrollHeight + "px";
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var sheet = document.querySelector("[data-sheet]");
    var openBtn = document.querySelector("[data-menu-open]");
    var closeEls = [].slice.call(document.querySelectorAll("[data-menu-close]"));
    if (!sheet || !openBtn) return;
    function open() { sheet.classList.add("open"); }
    function close() { sheet.classList.remove("open"); }
    openBtn.addEventListener("click", open);
    closeEls.forEach(function (el) { el.addEventListener("click", close); });
    sheet.addEventListener("click", function (e) { if (e.target === sheet) close(); });
    [].slice.call(sheet.querySelectorAll("a")).forEach(function (a) { a.addEventListener("click", close); });
  }

  /* ---------- Sticky buy bar ---------- */
  function initSticky() {
    var bar = document.querySelector("[data-stickybuy]");
    if (!bar) return;
    function onScroll() { bar.classList.toggle("show", window.scrollY > 680); }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Smooth-scroll for in-page anchors ---------- */
  function initAnchors() {
    [].slice.call(document.querySelectorAll('a[href^="#"]')).forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href");
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" }); }
      });
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function showToast(msg) {
    var t = document.querySelector("[data-toast]");
    if (!t) return;
    if (msg) t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  function updateCartCount(count) {
    [].slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }

  /* ---------- AJAX cart ---------- */
  function initCart() {
    var buyButtons = [].slice.call(document.querySelectorAll("[data-buy]"));
    var qtyBox = document.querySelector("[data-qty]");

    function currentQty() {
      if (!qtyBox) return 1;
      var v = qtyBox.querySelector("[data-qty-val]");
      return Math.max(1, parseInt(v && v.textContent, 10) || 1);
    }

    if (qtyBox) {
      var val = qtyBox.querySelector("[data-qty-val]");
      qtyBox.querySelector("[data-qty-dec]").addEventListener("click", function () {
        val.textContent = Math.max(1, (parseInt(val.textContent, 10) || 1) - 1);
      });
      qtyBox.querySelector("[data-qty-inc]").addEventListener("click", function () {
        val.textContent = (parseInt(val.textContent, 10) || 1) + 1;
      });
    }

    buyButtons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        var variantId = btn.getAttribute("data-variant-id");
        var url = btn.getAttribute("data-cta-url");
        // No product wired in the theme editor → just navigate.
        if (!variantId) {
          if (url && url !== "#") { window.location.href = url; }
          return;
        }
        e.preventDefault();
        var qty = btn.hasAttribute("data-buy-qty") ? currentQty() : 1;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || "No se pudo agregar");
            showToast("¡Agregado al carrito!");
            return fetch("/cart.js").then(function (r) { return r.json(); });
          })
          .then(function (cart) { if (cart && typeof cart.item_count === "number") updateCartCount(cart.item_count); })
          .catch(function (err) { showToast(String(err.message || err)); });
      });
    });
  }

  ready(function () {
    initReveal();
    initParallax();
    initCountUp();
    initFaq();
    initMenu();
    initSticky();
    initAnchors();
    initCart();
  });
})();
